import React from "react";

const WhyChooseGlowTech = () => {
  const items = [
    {
      side: "left",
      text: "AI-Powered Solutions",
      desc: "We leverage advanced AI technology to deliver smarter, more efficient services.",
    },
    {
      side: "right",
      text: "Expert Team",
      desc: "Our experienced professionals bring industry expertise to every project.",
    },
    {
      side: "left",
      text: "Data-Driven Results",
      desc: "We use data to optimize performance and deliver measurable outcomes.",
    },
    {
      side: "right",
      text: "Proven Success",
      desc: "Our track record of successful outcomes speaks for itself.",
    },
    {
      side: "left",
      text: "Ongoing Support",
      desc: "We provide continuous support and optimization to ensure long-term growth.",
    },
  ];

  return (
    <div className="relative w-full max-w-5xl mx-auto py-6 px-4">
      <h2 className="text-2xl md:text-4xl font-bold text-center text-gray-800 mb-16">
        Why Choose Glow Tech Solutions?
      </h2>

      {/* Vertical line (centered) */}
      <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 h-[550px] w-[3px] bg-black"></div>

      <div className="space-y-16">
        {items.map((item, index) => (
          <div
            key={index}
            className="relative flex flex-col md:flex-row items-center"
          >
            {/* Left Side */}
            {item.side === "left" && (
              <>
                <div className="md:w-1/2 w-full flex md:justify-end justify-center pr-0 md:pr-4 mb-4 md:mb-0">
                  <div className="flex items-center">
                    <div className="flex flex-col text-center md:text-right mr-2">
                      <span className="font-semibold text-gray-800 text-md md:text-xl whitespace-nowrap">
                        {item.text}
                      </span>
                      <span className="text-sm text-gray-900">{item.desc}</span>
                    </div>

                    <div className="w-3 h-3 bg-black rounded-full mr-2"></div>
                    <div className="w-6 h-0.5 bg-black"></div>
                  </div>
                </div>
                <div className="md:w-1/2 w-0"></div>
              </>
            )}

            {/* Right Side */}
            {item.side === "right" && (
              <>
                <div className="md:w-1/2 w-0"></div>
                <div className="md:w-1/2 w-full flex md:justify-start justify-center pl-0 md:pl-4">
                  <div className="flex items-center">
                    <div className="w-6 h-0.5 bg-black mr-2"></div>
                    <div className="w-3 h-3 bg-black rounded-full mr-2"></div>

                    <div className="flex flex-col text-center md:text-left">
                      <span className="font-semibold text-gray-800 text-sm md:text-xl whitespace-nowrap">
                        {item.text}
                      </span>
                      <span className="text-sm text-gray-900">{item.desc}</span>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhyChooseGlowTech;
